import React from 'react';
import { useApi, api } from '@gik/core/api';
import { UI } from '@gik/ui';
import { useUserStore } from '@gik/core/store/UserStore';
import { auth } from '@gik/auth';

interface AddToFavouritesButtonProps {
  type: 'articles' | 'products';
  itemId: string;
  child(
    onClick: (ev: React.MouseEvent<HTMLElement>) => void,
    isLoading: boolean,
    isFavourited: boolean
  ): React.ReactElement;
}

function AddToFavouritesButton({ type, itemId, child }: AddToFavouritesButtonProps): React.ReactElement {
  const userStore = useUserStore();
  const userId = userStore.id;

  // TODO: should just retrieve the favourite by item ID
  const { data: favouriteIds, isValidating: isLoading, mutate: reloadFavourites } = useApi<string[]>(
    userId ? `users/${userId}/favorites?type=${type}&per_page=1000` : null
  );

  const isFavourited = favouriteIds && favouriteIds.indexOf(itemId) >= 0;

  const onClick = async () => {
    if (!userId) {
      auth.loginOrSignup();
      return;
    }
    // optimistic update
    reloadFavourites(isFavourited ? favouriteIds.filter(id => id !== itemId) : [...favouriteIds, itemId], false);
    if (!isFavourited) {
      try {
        await api.post(`users/${userId}/favorites`, {
          body: JSON.stringify({
            item_id: itemId,
            type: type,
          }),
        });
        UI.notifySuccess('Item successfully added to favorites');
      } catch (err) {
        UI.notifyError('Failed to add item to favorites');
      }
    } else {
      try {
        await api.delete(`users/${userId}/favorites/${itemId}?type=${type}`);
        UI.notifySuccess('Item successfully removed from favorites');
      } catch (err) {
        UI.notifyError('Failed to remove item from favorites');
      }
    }
    // reload again, this time getting the real value
    reloadFavourites();
  };

  return child(onClick, isLoading, isFavourited);
}

export default React.memo(AddToFavouritesButton, () => true);
